import { ref } from 'vue';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';
import useModalStore from '@global/stores/useModalStore';
import fireCancelOrderGAEvent from '@global/gtm/orderGTM';

const { deleteOrderAPI, getOrderAPI } = useAxiosAPI();

const modalStore = useModalStore();
const { closeModal } = modalStore;

function useCancelOrder(props) {
  const lockBtn = ref(false);
  const isOrderLoading = ref(false);

  async function confirmCancel() {
    lockBtn.value = true;
    isOrderLoading.value = true;

    try {
      const deleteResponse = await deleteOrderAPI({
        params: {
          TransactionID: props.transactionId,
        },
      });
      if (deleteResponse.data.Code === 200) {
        const getResponse = await getOrderAPI({
          params: {
            TransactionID: props.transactionId,
          },
        });

        fireCancelOrderGAEvent({
          orderID: props.transactionId,
          orderItems: getResponse.data.Response,
        });
        // 在所有操作完成後再重新加載頁面
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  }

  return {
    lockBtn,
    isOrderLoading,
    confirmCancel,
  };
}

export default useCancelOrder;
